module.exports = __webpack_public_path__ + "img/data-quality-record-labels-level-1.1afea930.svg";